<template>
  <div class="loan-list">
    <!--导航-->
    <template v-if="detail">
    <div class="dk-nav">
      <van-nav-bar
              fixed
              :title="detail.category_name"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--贷款详情-->
    <div>
      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>详情</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>适合人群：{{detail.shiheren}}</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>额度：{{detail.kedaie}}万</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>基本要求：{{detail.jibenyaoqiu}}</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>利息：{{detail.daikuanlirun}}元/万元/月</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>成功人数：{{detail.chenggongrenshu}}</span>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>申请条件</span>
          </div>
        </div>
        <div class="van-cell" style="margin-top: 0; margin-bottom: 0;padding-top: 0; padding-bottom: 0;">
          <div class="van-cell__title">
            <div class="van-cell__label" style="white-space: pre-wrap; line-height: 22px; margin: 0; padding: 0;">
              {{detail.shenqingtiaojian | trim}}
            </div>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>所需资料</span>
          </div>
        </div>
        <div class="van-cell" style="margin-top: 0; margin-bottom: 0;padding-top: 0; padding-bottom: 0;">
          <div class="van-cell__title">
            <div class="van-cell__label" style="white-space: pre-wrap; line-height: 22px; margin: 0; padding: 0;">
              {{detail.suoxuziliao}}
            </div>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>办理流程</span>
          </div>
        </div>
        <div class="van-cell" style="margin-top: 0; margin-bottom: 0;padding-top: 0; padding-bottom: 0;">
          <div class="van-cell__title">
            <div class="van-cell__label" style="white-space: pre-wrap; line-height: 22px; margin: 0; padding: 0;">
              {{detail.banliliucheng}}
            </div>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>备注说明</span>
          </div>
        </div>
        <div class="van-cell" style="margin-top: 0; margin-bottom: 0;padding-top: 0; padding-bottom: 0;">
          <div class="van-cell__title">
            <div class="van-cell__label" style="white-space: pre-wrap; line-height: 22px; margin: 0; padding: 0;">
              {{detail.beizhu}}
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>

    <!-- 贷款门店 -->
    <div style="margin-top:10px;">
      <van-cell title="查看附近的门店" value="查看全部" to="/shop/list"/>
    </div>
    <div class="loan-shop">
      <template v-if="shop.data">
        <div class="van-cell-group van-hairline--top-bottom van-panel" style="margin-bottom: 6px; font-size: 12px;" v-for="(item,index) in sortBykey(filterBy(shop.data,city),'coordinate')" v-if="index<3">
          <div class="van-cell van-panel__header dk-header-after">
            <div class="van-cell__title">
              <span style="float: left;">{{item.title}}</span>
              <span style="float: right;">{{item.coordinate}}</span>
              <div class="van-cell__label" style="clear: both;">{{item.province+item.city+item.district+item.address}}</div>
            </div>
          </div>
          <div class="van-panel__content"></div>
          <div class="van-panel__footer van-hairline--top dk-footer-after">
            <button class="van-button van-button--info van-button--small" @click="getTel(item.phone)">
              <div class="van-button__content">
                <span class="van-button__text">电话:{{item.phone}}</span>
              </div>
            </button>
            <button class="van-button van-button--info van-button--small" style="margin-left: 10px;"  @click="goUrl('/shop/detail/'+item.id)">
              <div class="van-button__content">
                <span class="van-button__text">电子地图</span>
              </div>
            </button>
          </div>
        </div>
      </template>
    </div>

    <!--标题-->
    <div style="margin-top: 10px;">
      <van-cell title="贷款专家" value="查看全部" to="/expert/list"/>
    </div>
    <!--门店内容-->
    <div>
      <template v-if="expert.data">
      <div class="van-card" v-for="(item,index) in filterBy(expert.data,city)" v-if="index<2">
        <div class="van-card__header">
          <a class="van-card__thumb">
            <div class="van-image" style="width: 100%; height: 100%;">
              <img :src="uploadsUrl+item.pictrue" class="van-image__img" style="object-fit: cover;">
            </div>
          </a>
          <div class="van-card__content">
            <div>
              <div class="van-card__title van-multi-ellipsis--l2">{{item.title}}</div>
              <div class="van-card__desc van-ellipsis">{{item.description}}</div>
              <div class="van-card__desc van-ellipsis">咨询量：<span style="color:#f60;">{{item.chengjiaoling}}个</span></div>
              <div class="van-card__desc van-ellipsis">从业经验：<span style="color:#f60;">{{item.congyejingyan}}年</span></div>
            </div>
          </div>
        </div>
        <div class="van-card__footer">
          <button class="van-button van-button--default van-button--small" style="background-color: #9bd3f4; color: #fff;" @click="getTel(item.phone)">
            <div class="van-button__content">
              <span class="van-button__text">电话咨询</span>
            </div>
          </button>
          <button class="van-button van-button--default van-button--small" style="background-color: #00a13a; color: #fff;" @click="getGo()">
            <div class="van-button__content">
              <span class="van-button__text">在线咨询</span>
            </div>
          </button>
        </div>
      </div>
      </template>
    </div>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'LoanList',
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            detail: state => state.article.article_detail.data,
            shop: state => state.shop.shop_list,
            lng: state => state.cityData.lng,
            lat: state => state.cityData.lat,
            expert: state => state.expert.expert_list
        })
    },
    methods: {
      ...mapActions(['requestArticleDetail','requestShop','requestExpert']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/loan/list/'+this.detail.category_id+'?name='+this.detail.category_name});
        },
        getTel(val) {
           return window.location.href = 'tel:'+val
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        },
        getGo() {
           return window.location.href="http://www.dai12345.com/kf.html";
        },
        sortBykey(ary, key) {
          return ary.sort(function (a, b) {
            let x = a[key].substring(0,a[key].indexOf("."))
            let y = b[key].substring(0,b[key].indexOf("."))
            return x-y
          })
        }
    },
    filters: {
      trim(value) {
        return value.replace(/(^\s*)|(\s*$)/g, "");
      }
    },
    mounted() {
        this.requestArticleDetail({"thit":this,"id":this.$route.params.id});
        this.requestShop({"thit":this,"lnglat":this.lng+","+this.lat,"city":this.city});
        this.requestExpert({"thit":this,"city":this.city});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
